import type { ConfigLookup, PaletteTokens } from './color-sound-config-resolver';
import { colorSoundConfigStore } from './color-sound-config-store';

// Both read a MobX observable, so callers must be `observer` components to re-render when the config
// changes. The store returns the same lookup object for the same color, so the result is safe to use
// as a hook dependency.

export function usePriorityColor(
    priorityId: number | null | undefined,
    agencyTypeGlobalAttrId: number | null | undefined
): ConfigLookup<PaletteTokens> {
    return colorSoundConfigStore.resolvePriorityColor(priorityId, agencyTypeGlobalAttrId);
}

export function useUnitStateColor(
    unitStateId: number | null | undefined
): ConfigLookup<PaletteTokens> {
    return colorSoundConfigStore.resolveUnitStateColor(unitStateId);
}
